const bodyEl = document.querySelector('html');
const headerEl = document.querySelector('.header');
const drawerPop = document.querySelectorAll('.header__inner-sticky .drawer-menu.popover');
const headerStickyEl = document.querySelector('#shopify-section-header-sticky')
const headerMain = document.querySelector('#shopify-section-header')

const menuToggle = document.querySelector('#shopify-section-header .header__menu-icon');
const menuToggleSticky = document.querySelector('#shopify-section-header-sticky .header__menu-icon');
const menuToggleClose = document.querySelector('#shopify-section-header .drawer-menu__close-icon');
const menuToggleCloseSticky = document.querySelector('#shopify-section-header-sticky .drawer-menu__close-icon');
const scrollLock = () => {
    const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
    bodyEl.style.position = 'fixed';
    bodyEl.style.width = '100%';
    bodyEl.style.height = '100%';
    bodyEl.style.overflow = 'hidden';
    bodyEl.style.top = `-${scrollY}`;
    headerEl.classList.add('drawer-open');
    drawerPop.forEach(item => {
        item.classList.add('active');
        setTimeout(() => {
            item.classList.add('visible');
        }, 200);
    })
};
const scrollAble = () => {
    const scrollY = bodyEl.style.top;
    bodyEl.style.position = '';
    bodyEl.style.top = '';
    bodyEl.style.height = '';
    bodyEl.style.overflow = '';
    document.body.style.overflow = '';
    headerEl.classList.remove('drawer-open');
    drawerPop.forEach(item => {
        setTimeout(() => {
            item.classList.remove('active');
        }, 200);
        item.classList.remove('visible');
    })
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});


if(menuToggleClose) {
    menuToggleClose.addEventListener('click', (e) => {
        e.preventDefault();
        setTimeout(() => {
            scrollAble();
            headerMain.style.visibility = 'visible'
            headerStickyEl.style.visibility = 'hidden' 
            headerStickyEl.style.visibility = 'hidden'
            setTimeout(() => {
                document.body.classList.remove('drawer-opened');
            }, 500);
        }, 200);
    })
}
if(menuToggleCloseSticky) {
    menuToggleCloseSticky.addEventListener('click', (e) => {
        e.preventDefault();
        setTimeout(() => {
            scrollAble();
            headerMain.style.visibility = 'hidden'
            headerStickyEl.style.visibility = 'visible' 
            setTimeout(() => {
                document.body.classList.remove('drawer-opened');
            }, 500);
        }, 200);
    })
}
if(menuToggle) {
    menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('drawer-opened');
        setTimeout(() => {
            scrollLock();
            setTimeout(() => {
                headerMain.style.visibility = 'visible'
                headerStickyEl.style.visibility = 'hidden'
            }, 200);
        }, 200);
    })
}
if(menuToggleSticky) {
    menuToggleSticky.addEventListener('click', (e) => {
        e.preventDefault();
        scrollLock();
        document.body.classList.add('drawer-opened');
        setTimeout(() => {
            headerMain.style.visibility = 'hidden'
            headerStickyEl.style.visibility = 'visible' 
        }, 150);
    })
}

